import {
  SET_STREAM,
  SET_VIDEO_CONTROLLED,
  SET_VIDEO_DISPLAY,
  SET_CAPTIONS_DISPLAY,
  SET_AUDIO_SETTING,
  GOT_CAPTIONS,
  GET_SERVER_TIME,
  SET_SERVER_TIME,
  SET_PACKET_LOST,
  SET_NUM_VIEWERS,
  SHOW_SET_VIDEO_DISPLAY,
  SET_FRAME_RATE,
  SET_TOTAL_PACKETS_VIDEO,
  SET_TOTAL_PACKETS_AUDIO,
  SET_BITRATE_SENT
} from 'types/actions/stream'
import API from 'store/api'
import moment from 'moment'
import batch from 'react-redux'
import { DataUsage } from '@material-ui/icons'

// import { objectToFormData } from 'object-to-formdata'

// https://stackoverflow.com/questions/22783108/convert-js-object-to-form-data
const objToForm = item => {
  var formData = new FormData()
  for (var key in item) {
    formData.append(key, item[key])
  }
  return formData
}

export const setStream = data => ({
  type: SET_STREAM,
  data
})

export const setVideoControlled = (videoType = '', controlled = false) => ({
  type: SET_VIDEO_CONTROLLED,
  videoType,
  controlled
})

export const setVideoDisplay = displayVideo => ({
  type: SET_VIDEO_DISPLAY,
  displayVideo
})

export const showSetVideoDisplay = showDisplayVideo => ({
  type: SHOW_SET_VIDEO_DISPLAY,
  showDisplayVideo
})

export const setCaptionsDisplay = captions => ({
  type: SET_CAPTIONS_DISPLAY,
  captions
})

export const setAudioSetting = audioSetting => ({
  type: SET_AUDIO_SETTING,
  audioSetting
})

export const gotCaptions = gotCaptions => ({
  type: GOT_CAPTIONS,
  gotCaptions
})

export const setServerTime = servertime => ({
  type: SET_SERVER_TIME,
  servertime
})

export const setPacketLost = packetLost => ({
  type: SET_PACKET_LOST,
  packetLost
})

export const setNumViewers = numViewers => ({
  type: SET_NUM_VIEWERS,
  numViewers
})

export const setBitrateSent = bitrateSent => ({
  type: SET_BITRATE_SENT,
  bitrateSent
})

export const setTotalPacketsVideo = totalVideoPackets => ({
  type: SET_TOTAL_PACKETS_VIDEO,
  totalVideoPackets
})

export const setTotalPacketsAudio = totalAudioPackets => ({
  type: SET_TOTAL_PACKETS_AUDIO,
  totalAudioPackets
})

export const setFrameRate = frameRate => ({
  type: SET_FRAME_RATE,
  frameRate
})

export const updateStream = (uuid, postdata) => {
  return dispatch => {
    const formData = objToForm({
      appname: 'WebRTCAppEE',
      method: 'PUT',
      endpoint: `broadcasts/${uuid}`,
      postdata: JSON.stringify(postdata)
    })
    const deferred = new Promise((resolve, reject) => {
      API.post(`/live/mediaserver`)
        .send(formData)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          console.error(err)
        })
    })
    return deferred
  }
}

export const createStream = (eid, data) => {
  return dispatch => {
    const formData = objToForm(data)
    const deferred = new Promise((resolve, reject) => {
      API.post(`/live/urls/${eid}/create`)
        .send(formData)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          console.error(err)
        })
    })
    return deferred
  }
}

export const makeStreamLive = (streamId, eid, data) => {
  return dispatch => {
    const formData = objToForm(data)
    const deferred = new Promise((resolve, reject) => {
      API.post(`/live/urls/${eid}/update/${streamId}`)
        .send(formData)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          resolve(data)
        })
        .catch(err => {
          console.error(err)
        })
    })
    return deferred
  }
}

export const getServerTime = streamid => {
  return dispatch => {
    return API.get(`/live/playhead/${streamid}`)
      .then(reponse => {
        if (!reponse.ok) {
          throw Error(reponse.statusText)
        }
        return reponse
      })
      .then(response => response.body)
      .then(data => {
        //dispatch(setServerTime(data.servertime))
        return data.playhead_offset
      })
      .catch(err => {
        console.error(err)
      })
  }
}

export const getStreamStats = streamid => {
  return dispatch => {
    return API.get(`/live/broadcastinfo/${streamid}`)
      .then(reponse => {
        if (!reponse.ok) {
          throw Error(reponse.statusText)
        }
        return reponse
      })
      .then(response => response.body)
      .then(data => {
        if (data.msg === 'success') {
          dispatch(setNumViewers(data.webRTCViewerCount))
          dispatch(setFrameRate(data.frameRate))
          dispatch(setTotalPacketsVideo(data.totalVideoPackets))
          dispatch(setTotalPacketsAudio(data.totalAudioPackets))
          dispatch(setBitrateSent(data.sendBitrate))
        }
        return data
      })
      .catch(err => {
        console.error(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/stream.js